import { matchesUA } from "browserslist-useragent";
import browserslistrc from "../../../.browserslistrc?raw";
import { userAgentOptions } from "../../userAgentOptions";

export function isOutdatedBrowser(userAgent: string): boolean {
	return !matchesUA(userAgent, {
		...userAgentOptions,
		browsers: browserslistrc.split("\n").filter(Boolean),
		path: ".", // Otherwise it uses `process.cwd()` and we don't want that.
	});
}
